import { joinCn } from '@/component/UI/util';

const style = {
  tooltipContent: joinCn(
    'max-w-[400px] bg-black px-2 py-1 text-body-s break-words text-white',
  ),
};

export default style;
